import React from "react";
import Brandfolder from "./brandfolder";
import _ from "underscore";

export default class BrandfolderList extends React.Component {
    state = {
        loading: true,
        error: false,
        brandfolders: []
    };

    componentDidMount() {
        this.getBrandfolders();
    }

    getBrandfolders() {
        return $.ajax({
            url: "/api/v4/brandfolders",
            type: "GET",
            context: this,
            headers: { Authorization: `Bearer ${this.props.jwt}` },
            success: function(response) {
                let brandfolders = _.sortBy(response.data, brandfolder =>
                    brandfolder.attributes.name.toUpperCase()
                );
                this.setState({ loading: false, brandfolders: brandfolders });
            }
        });
    }

    renderBackButtonOrNotification() {
        if (!!this.props.selected_brandfolder) {
            return (
                <div
                    className="adobe-brandfolder-list-header"
                    onClick={this.props.toggleBrandfolderList}
                >
                    <i className="fa fa-arrow-left" /> Back to Menu
                </div>
            );
        } else {
            return (
                <div className="adobe-brandfolder-list-header">
                    <p>Select a Brandfolder</p>
                </div>
            );
        }
    }

    renderBrandfolders() {
        if (!!this.state.loading) {
            return (
                <div className="adobe-notification">
                    <i className="fa fa-spinner fa-spin" />
                </div>
            );
        } else if (!!this.state.error) {
            return (
                <div className="adobe-notification">
                    <i className="fa fa-exclamation-triangle" />
                    <p>Unable to load Brandfolders at this time</p>
                </div>
            );
        } else if (this.state.brandfolders.length === 0) {
            return (
                <div className="adobe-notification">
                    <i className="fa fa-commenting" />
                    <p>No Brandfolders to choose from</p>
                </div>
            );
        } else {
            const brandfolders = this.state.brandfolders;
            const brandfolder_list = brandfolders.map(brandfolder => {
                return (
                    <li
                        key={brandfolder.id}
                        onClick={() =>
                            this.props.selectBrandfolder(brandfolder)
                        }
                    >
                        <Brandfolder
                            brandfolder={brandfolder.attributes}
                        />
                    </li>
                );
            });
            return <ul>{brandfolder_list}</ul>;
        }
    }

    render() {
        return (
            <div>
                {this.renderBackButtonOrNotification()}
                <div className="adobe-brandfolder-list">
                    {this.renderBrandfolders()}
                </div>
            </div>
        );
    }
}
